$(document).ready(function () {
    function validateField(field) {
        var validation = false;
        if (field.attr("type") == "email") {
            validation = validateEmail(field);
        } else if (field.attr("type") == "password") {
            if (!field.hasClass("confirm-password")) {
                validation = validatePassword(field);
            } else {
                validation = validateConfirmPassword(field);
            }
        } else if (field.attr("type") == "text") {
            if (field.hasClass("website-validation")) {
                validation = validateWebsite(field);
            } else {
                validation = validateText(field);
            }
        } else if (field[0]["localName"] === "textarea") {
            validation = validateTextarea(field);
        } else if (field[0]["localName"] === "select") {
            validation = validateSelect(field);
        } else if (field.attr("type") == "tel") {
            validation = validatePhone(field);
        } else if (field.attr("type") == "checkbox") {
            validation = validateCheckbox(field);
        } else if (field.attr("type") == "file") {
            validation = validateFileUpload(field);
        } else if (field.attr("name") == "fax") {
            validation = validateFax(field);
        } else if (field.attr("type") == "number") {
            validation = validateNumber(field);
        }

        if (validation) {
            field.next(".form-validation-error").remove();
        }
        return validation;
    }

    function validateEmail(field) {
        if (!emptyCheck(field)) return !1;
        const email = field.val();
        function invalidEmail() {
            (field.next(".form-validation-error").remove(),
                $(
                    '<span class="form-validation-error">Please enter a valid email address</span>',
                ).insertAfter(field));
        }
        const emailParts = email.split("@");
        if (emailParts.length != 2) return (invalidEmail(), !1);
        const localPart = emailParts[0],
            domainPart = emailParts[1];
        if (
            !/^[a-zA-Z0-9!#$%&'*+\-/=?^_`{|}~]+(\.[a-zA-Z0-9!#$%&'*+\-/=?^_`{|}~]+)*$/.test(
                localPart,
            ) ||
            localPart.length > 64 ||
            localPart.startsWith(".") ||
            localPart.endsWith(".") ||
            localPart.includes("..") ||
            domainPart.includes("--") ||
            domainPart.startsWith("-") ||
            domainPart.endsWith("-") ||
            domainPart.length > 255
        )
            return (invalidEmail(), !1);
        const tldRegex = /^[a-zA-Z]{2,}$/,
            domainParts = domainPart.split("."),
            domainNameRegex = /^[a-zA-Z0-9]+([-][a-zA-Z0-9]+)*$/;
        if (
            !domainNameRegex.test(domainParts[0]) ||
            domainParts.length < 2 ||
            !tldRegex.test(domainParts[domainParts.length - 1])
        )
            return (invalidEmail(), !1);
        for (let i = 0; i < domainParts.length - 1; i++)
            if (!domainNameRegex.test(domainParts[i])) return (invalidEmail(), !1);
        if (field.parents(".wac-login").length) {
            field.next(".form-validation-error").remove();
            let isValid = !1;
            return (
                $.ajax({
                    type: "GET",
                    url: `${applicationUrl}/api/partner`,
                    data: { email },
                    async: !1,
                    success: function (data) {
                        data
                            ? ($(
                                '<span class="form-validation-error">Email already exists. Please use a different email.</span>',
                            ).insertAfter(field),
                                (isValid = !1))
                            : (console.log("emailcheck false"),
                                field.next(".form-validation-error").remove(),
                                (isValid = !0));
                    },
                }),
                isValid
            );
        } else return (field.next(".form-validation-error").remove(), !0);
    }
    function validatePassword(field) {

        // ===== LOGIN PAGE =====
        if (field.attr("id") === "CustomerPassword") {
            return emptyCheck(field); // only required validation
        }

        // ===== REGISTER PAGE ONLY BELOW =====
        if (!emptyCheck(field)) return false;

        const password = field.val();
        field.next(".form-validation-error").remove();

        // length check
        if (password.length < 8 || password.length > 40) {
            $(
                '<span class="form-validation-error">Password must be between 8 and 40 characters</span>'
            ).insertAfter(field);
            return false;
        }

        // uppercase check
        if (!/[A-Z]/.test(password)) {
            $(
                '<span class="form-validation-error">Password must contain at least one uppercase letter</span>'
            ).insertAfter(field);
            return false;
        }

        // lowercase check
        if (!/[a-z]/.test(password)) {
            $(
                '<span class="form-validation-error">Password must contain at least one lowercase letter</span>'
            ).insertAfter(field);
            return false;
        }

        // number check
        if (!/[0-9]/.test(password)) {
            $(
                '<span class="form-validation-error">Password must contain at least one number</span>'
            ).insertAfter(field);
            return false;
        }

        // special char check
        if (!/[@$!%*?&^#()_\-+=]/.test(password)) {
            $(
                '<span class="form-validation-error">Password must contain at least one special character</span>'
            ).insertAfter(field);
            return false;
        }

        field.next(".form-validation-error").remove();
        return true;
    }
    function validateConfirmPassword(field) {
        return field.val() != "" &&
            field.val() != field.closest("form").find("#password").val()
            ? (field.next(".form-validation-error").remove(),
                $(
                    '<span class="form-validation-error">Passwords do not match</span>',
                ).insertAfter(field),
                !1)
            : emptyCheck(field);
    }
    function validateText(field) {
        return field.val().length < 3 &&
            field.val() !== "" &&
            field.hasClass("min-3-characters")
            ? (field.next(".form-validation-error").remove(),
                $(
                    '<span class="form-validation-error">Please enter at least 3 characters</span>',
                ).insertAfter(field),
                !1)
            : field.val().length > 40 &&
                field.val() !== "" &&
                field.hasClass("max-40-characters")
                ? (field.val(field.val().substring(0, 40)),
                    field.next(".form-validation-error").remove(),
                    $(
                        '<span class="form-validation-error">Maximum of 40 characters allowed</span>',
                    ).insertAfter(field),
                    !1)
                : field.val().length > 100 &&
                    field.val() !== "" &&
                    field.hasClass("max-100-characters")
                    ? (field.val(field.val().substring(0, 100)),
                        field.next(".form-validation-error").remove(),
                        $(
                            '<span class="form-validation-error">Maximum of 100 characters allowed</span>',
                        ).insertAfter(field),
                        !1)
                    : field.val().length > 255 &&
                        field.val() !== "" &&
                        field.hasClass("max-255-characters")
                        ? (field.val(field.val().substring(0, 255)),
                            field.next(".form-validation-error").remove(),
                            $(
                                '<span class="form-validation-error">Maximum of 255 characters allowed</span>',
                            ).insertAfter(field),
                            !1)
                        : emptyCheck(field);
    }
    function validateWebsite(field) {
        let website = field.val();
        return website.length > 255
            ? (field.next(".form-validation-error").remove(),
                $(
                    '<span class="form-validation-error">Website URL must not exceed 255 characters</span>',
                ).insertAfter(field),
                !1)
            : /^(https?:\/\/)?([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(\/\S*)?$/.test(
                website,
            )
                ? (field.next(".form-validation-error").remove(), !0)
                : (field.next(".form-validation-error").remove(),
                    $(
                        '<span class="form-validation-error">Please enter a valid website URL</span>',
                    ).insertAfter(field),
                    !1);
    }
    function validateSelect(field) {

        // 🔴 treat --- as empty (country default option)
        if (field.val() === '---') {
            field.val('');
        }
        return emptyCheck(field);
    }
    function validatePhone(field) {
        if (!emptyCheck(field)) return !1;
        const phone = field.val();
        function invalidPhone() {
            (field.next(".form-validation-error").remove(),
                $(
                    '<span class="form-validation-error">Please enter a valid phone number</span>',
                ).insertAfter(field));
        }
        if (phone.length < 6 || phone.length > 14) return (invalidPhone(), !1);
        if (field.parents(".wac-company").length) {
            field.next(".form-validation-error").remove();
            let isValid = !1;
            return (
                $.ajax({
                    type: "GET",
                    url: `${applicationUrl}/api/partner`,
                    data: { phone },
                    async: !1,
                    success: function (data) {
                        data
                            ? ($(
                                '<span class="form-validation-error">Phone number already exists. Please use a different phone number</span>',
                            ).insertAfter(field),
                                (isValid = !1))
                            : (field.next(".form-validation-error").remove(), (isValid = !0));
                    },
                }),
                isValid
            );
        } else return (field.next(".form-validation-error").remove(), !0);
    }
    function validateFax(field) {
        if (!emptyCheck(field)) return !1;
        let fax = field.val();
        function invalidFax() {
            (field.next(".form-validation-error").remove(),
                $(
                    '<span class="form-validation-error">Please enter a valid fax number</span>',
                ).insertAfter(field));
        }
        return fax.length < 7 || fax.length > 20
            ? (invalidFax(), !1)
            : /^(\+?\d{1,4})?[\s-]?(\(?\d{2,4}\)?)?[\s-]?\d{3,4}[\s-]?\d{4}$/.test(
                fax,
            )
                ? (field.next(".form-validation-error").remove(), !0)
                : (invalidFax(), !1);
    }
    function validateNumber(field) {
        return emptyCheck(field);
    }
    function validateCheckbox(field) {
        return emptyCheck(field);
    }
    function validateFileUpload(field) {
        if (!emptyCheck(field)) return !1;
        if (field[0].files.length != 0) {
            var fileName = field[0].files[0].name,
                uploadFileName = field.closest(".upload-wrapp").find(".upload-text");
            if (fileName != "") {
                (uploadFileName.text(fileName),
                    uploadFileName.addClass("upload-text-color"));
                var fileSize = field[0].files[0].size,
                    fileSizeMB = fileSize / (1024 * 1024);
                return fileSizeMB > 2
                    ? (field.next(".form-validation-error").remove(),
                        $(
                            '<span class="form-validation-error">The uploaded file is too large</span>',
                        ).insertAfter(field),
                        !1)
                    : !0;
            }
        }
    }

    $(
        "#ContactForm input, .add-new-address input, .edit-address input, #newsletter-section input, #create_customer input, #customer_login input, #RecoverPasswordForm form input",
    ).on("input keypress", function (e) {
        let trimmedValue = $(this).val().trim(),
            inputValue = $(this).val();
        if (
            (trimmedValue.replace(/\s/g, "").length || $(this).val(""),
                e.key === " " &&
                trimmedValue.length === 0 &&
                (e.preventDefault(), $(this).val("")),
                trimmedValue.length < inputValue.length &&
                /^\s/.test(inputValue) &&
                $(this).val(trimmedValue),
                $(this).attr("type") === "tel" || $(this).attr("type") === "number")
        ) {
            let trimmedValue2 = $(this).val().trim(),
                isNumber = /[0-9\-+]/.test(e.key);
            (!isNumber &&
                trimmedValue2.length === 0 &&
                (e.preventDefault(), $(this).val("")),
                isNumber || e.preventDefault());
        }
        if (
            $(this).attr("type") === "text" &&
            $(this).attr("data-field") !== "zip"
        ) {
            // allow only letters + space ALWAYS
            if (
                !/^[a-zA-Z\s]$/.test(e.key) &&
                e.key.length === 1 && // ignore control keys
                !e.ctrlKey &&
                !e.metaKey
            ) {
                e.preventDefault();
            }
        }

        var myArray = ["password", "file"];
        if ($.inArray($(this).attr("type"), myArray) != 0) {
            var sanitizedValue = inputValue.replace(/\s{2,}/g, " ");
            $(this).val(sanitizedValue);
        }
        $(this).hasClass("required")
            ? $(this).val() == ""
                ? emptyCheck($(this))
                : ($(this).next(".form-validation-error").remove(),
                    $(this).attr("type") === "email"
                        ? validateEmail($(this))
                        : $(this).attr("type") === "tel"
                            ? validatePhone($(this))
                            : $(this).attr("type") === "text"
                                ? $(this).hasClass("website-validation")
                                    ? validateWebsite($(this))
                                    : validateText($(this))
                                : $(this).attr("type") == "file"
                                    ? validateFileUpload($(this))
                                    : $(this).attr("type") == "password"
                                        ? $(this).hasClass("confirm-password")
                                            ? validateConfirmPassword($(this))
                                            : validatePassword($(this))
                                        : $(this).attr("type") == "number" &&
                                        validateNumber($(this)))
            : !$(this).hasClass("required") &&
            $(this).val() !== "" &&
            ($(this).attr("type") === "email"
                ? validateEmail($(this))
                : $(this).attr("type") === "tel"
                    ? validatePhone($(this))
                    : $(this).attr("type") === "text"
                        ? validateText($(this))
                        : $(this).attr("type") == "file"
                            ? validateFileUpload($(this))
                            : $(this).attr("name") == "fax"
                                ? validateFax($(this))
                                : $(this).attr("type") == "number" &&
                                validateNumber($(this)));
    });

    $(
        '#ContactForm button[type="submit"], .edit-address input[type="submit"], .add-new-address input[type="submit"], #newsletter-section button[type="submit"], #create_customer button[type="submit"], #customer_login button[type="submit"], #RecoverPasswordForm form input[type="submit"]',
    ).on("click", function (e) {
        var validated = false;
        var validationSuccess = true;
        var flag = 0;

        $(this)
            .closest("form")
            .find(
                'input.required:not([type="hidden"]):not([type="submit"]), textarea.required, select.required',
            )
            .each(function () {
                validated = validateField($(this));
                if (!validated) {
                    validationSuccess = false;
                    if (flag == 0) {
                        $(this).focus();
                        flag = 1;
                    }
                }
            });

        if (!validationSuccess) {
            e.preventDefault();
        }
    });
    ($(
        "input:not([type='file']).required, select.required, textarea.required",
    ).on("focusout", function () {
        emptyCheck($(this));
    }),
        $("select").on("change", function () {
            $(this).val() !== "" && $(this).next(".form-validation-error").remove();
        }));
    function emptyCheck(field) {
        let fieldName = "";
        return (
            (fieldName = field.attr("data-label")),
            ((field[0].localName === "select" &&
                field.attr("multiple") == "multiple" &&
                field.val().length == 0) ||
                field.val() === "" ||
                field.val() === null) &&
                field.hasClass("required")
                ? (field.next(".form-validation-error").remove(),
                    fieldName && (fieldName = fieldName.replace("*", "")),
                    $(
                        '<span  role="alert" aria-live="assertive" class="form-validation-error" role="alert" aria-live="assertive">' +
                        fieldName +
                        " is required</span>",
                    ).insertAfter(field),
                    !1)
                : !0
        );
    }
    $(".user-logout").on("click", function (event) {
        var confirmation = confirm("Are you sure you want to log out?");
        confirmation || event.preventDefault();
    });

    //   $(document).on('click', '.remove-cart-item', function (event) {
    //     var confirmation = confirm(
    //       'Are you sure you want to remove this item from the cart?'
    //     )
    //     confirmation || event.preventDefault()
    // });
});

/* =====================================
   EMAIL FIELD CHARACTER RESTRICTION

===================================== */

$(document).on("keypress", 'input[type="email"]', function (e) {
    const allowedChars = /^[a-zA-Z0-9@._+-]$/;

    // Allow control keys (backspace, arrows, tab, delete)
    if (e.ctrlKey || e.metaKey || e.key.length !== 1) {
        return;
    }

    if (!allowedChars.test(e.key)) {
        e.preventDefault();
    }
});

$(document).on("input", 'input[type="email"]', function () {
    const sanitizedValue = $(this)
        .val()
        .replace(/[^a-zA-Z0-9@._+-]/g, "");

    if ($(this).val() !== sanitizedValue) {
        $(this).val(sanitizedValue);
    }
});

/* =====================================
   PHONE ZERO / REPEATED DIGIT GUARD
 
===================================== */

// Detect spam phone numbers like 0000000 or 1111111
function isSpamPhoneNumber(phone) {
    const digits = phone.replace(/\D/g, "");

    // All zeros
    if (/^0+$/.test(digits)) return true;

    // Same digit repeated
    if (/^(\d)\1+$/.test(digits)) return true;

    return false;
}

// Remove spam error once user corrects input
$(document).on("input", 'input[type="tel"]', function () {
    if (!isSpamPhoneNumber($(this).val())) {
        $(this).next(".form-validation-error.zero-phone-error").remove();
    }
});

// Block form submission ONLY for spam phone numbers
$(document).on(
    "click",
    '#ContactForm button[type="submit"], \
   .edit-address input[type="submit"], \
   .add-new-address input[type="submit"], \
   #newsletter-section button[type="submit"], \
   #create_customer button[type="submit"], \
   #customer_login button[type="submit"], \
   #RecoverPasswordForm form input[type="submit"]',
    function (e) {
        let blocked = false;

        $(this)
            .closest("form")
            .find('input[type="tel"].required')
            .each(function () {
                if (isSpamPhoneNumber($(this).val())) {
                    $(this).next(".form-validation-error").remove();
                    $(
                        '<span class="form-validation-error zero-phone-error">Phone number cannot contain all identical or repeated digits</span>',
                    ).insertAfter($(this));

                    if (!blocked) $(this).focus();
                    blocked = true;
                }
            });

        if (blocked) e.preventDefault();
    },
);

/* =====================================
   PHONE FIELD – PASTE & INPUT SANITIZER
   (PARALLEL | DOES NOT AFFECT OLD CODE)
===================================== */

(function () {
    // Handle paste: allow ONLY numbers
    $(document).on("paste", 'input[type="tel"]', function (e) {
        e.preventDefault();

        const pastedText =
            (e.originalEvent || e).clipboardData.getData("text") || "";

        const numbersOnly = pastedText.replace(/\D/g, "");

        // Insert cleaned numeric value
        if (document.queryCommandSupported("insertText")) {
            document.execCommand("insertText", false, numbersOnly);
        } else {
            // Fallback
            $(this).val($(this).val() + numbersOnly);
        }
    });

    // Handle autofill / drag / mobile paste safety
    $(document).on("input", 'input[type="tel"]', function () {
        const sanitized = $(this).val().replace(/\D/g, "");
        if ($(this).val() !== sanitized) {
            $(this).val(sanitized);
        }
    });
})();
/* =====================================
   MESSAGE FIELD HTML BLOCK (COLLISION SAFE)
===================================== */

(function () {

    const htmlTagRegex = /<\/?[^>]+(>|$)/;
    const restrictedSymbolRegex = /[{}\[\]<>|^]/;

    const messageSelector = "#ContactForm-body";

    function showHtmlError(field) {

        // remove ONLY html error
        field.next(".html-tag-error").remove();

        // remove min-length error if present
        field.nextAll(".form-validation-error")
            .not(".html-tag-error")
            .remove();

        $('<span class="form-validation-error html-tag-error">Message contains invalid or restricted characters</span>')
            .insertAfter(field);
    }

    function removeHtmlError(field) {
        field.next(".html-tag-error").remove();
    }

    /* ===== REAL TIME CHECK ===== */
    $(document).on("input paste", messageSelector, function () {

        const field = $(this);
        const value = field.val();

        if (value && (htmlTagRegex.test(value) || restrictedSymbolRegex.test(value))) {
            showHtmlError(field);
        } else {
            removeHtmlError(field);
        }
    });

    /* ===== SUBMIT BLOCK ===== */
    $(document).on("click",
        '#ContactForm button[type="submit"]',
        function (e) {

            const field = $("#ContactForm-body");
            const value = field.val();

            if (value && (htmlTagRegex.test(value) || restrictedSymbolRegex.test(value))) {

                showHtmlError(field);
                field.focus();
                e.preventDefault();
            }
        });

})();

/* =====================================
   REAL-TIME TEXTAREA CHAR VALIDATION
   min: 3 | max: 1200
   Class-based, isolated
===================================== */

$(document).on("input", "textarea.max-1200-characters", function () {
    const MIN = 3;
    const MAX = 1200;
    const $field = $(this);
    const value = $field.val();
    const length = value.length;

    // Remove only this field's error
    $field.next(".form-validation-error").remove();

    // Max check (hard stop)
    if (length > MAX) {
        $field.val(value.substring(0, MAX));
        $(
            '<span class="form-validation-error">Maximum of 1200 characters allowed</span>',
        ).insertAfter($field);
        return;
    }

    // Min check (real-time)
    if (length > 0 && length < MIN) {
        $(
            '<span class="form-validation-error">Please enter at least 3 characters</span>',
        ).insertAfter($field);
        return;
    }
});

/* =====================================
   CART REMOVE BUTTON
===================================== */

document.addEventListener("click", function (e) {
    /* REMOVE BUTTON CLICK */
    if (e.target.closest(".js-remove-mini-cart")) {
        const confirmRemove = confirm(
            "Are you sure you want to remove this item from cart?",
        );

        if (!confirmRemove) {
            e.preventDefault();
            e.stopImmediatePropagation();
            return false;
        }
    }
});

document.addEventListener("click", function (e) {
    /* MINUS BUTTON */
    if (e.target.closest(".js-qty__minus")) {
        const input = e.target.closest(".js-qty").querySelector(".js-qty__input");

        if (input && parseInt(input.value) <= 1) {
            const confirmRemove = confirm(
                "Are you sure you want to remove this item from cart?",
            );

            if (!confirmRemove) {
                e.preventDefault();
                e.stopImmediatePropagation();
                return false;
            }
        }
    }
});

/* =========================================
   SEARCH CURSOR DELAY 1s + iPAD KEYBOARD FIX
   parallel safe code
========================================= */

document.addEventListener("click", function (e) {
    var openBtn = e.target.closest(".modal__toggle-open");
    var mobileBtn = e.target.closest(".modal__toggle-search-mobile");
    var closeBtn = e.target.closest(".search-modal__close-button");
    var overlay = e.target.closest(".modal-overlay");

    var input = document.getElementById("Search-In-Modal");
    if (!input) return;

    /* ---------- OPEN SEARCH ---------- */
    if (openBtn || mobileBtn) {
        // step 1: instant focus (required for iOS keyboard permission)
        input.focus();

        // step 2: remove cursor temporarily
        input.blur();

        // step 3: show cursor after 1 sec
        setTimeout(function () {
            input.focus();

            // place cursor at end properly
            var val = input.value;
            input.value = "";
            input.value = val;
        }, 1000); // 1 second delay
    }

    /* ---------- CLOSE SEARCH ---------- */
    if (closeBtn || overlay) {
        input.blur();

        // force keyboard close for iPad safari
        setTimeout(function () {
            input.setAttribute("readonly", "readonly");
            input.blur();
            input.removeAttribute("readonly");
        }, 10);
    }
});

/* ===============================
   PRODUCT SHARE BUTTON
================================*/
document.addEventListener("DOMContentLoaded", function () {
    var shareBtn = document.querySelector(".product-share-btn");
    if (!shareBtn) return;

    shareBtn.addEventListener("click", function () {
        var productUrl = window.location.href;
        var productTitle = document.title;

        // If browser supports native share
        if (navigator.share) {
            navigator
                .share({
                    title: productTitle,
                    text: "Check out this product",
                    url: productUrl,
                })
                .catch(function (err) {
                    console.log("Share cancelled", err);
                });
        } else {
            // Fallback: copy link
            navigator.clipboard.writeText(productUrl).then(function () {
                alert("Product link copied!");
            });
        }
    });
});



/* ================================
   NAME FIELD – STRICT LETTER ONLY
   Blocks numbers + symbols typing & paste
================================ */

$(document).on("keypress", '#ContactForm-name', function (e) {
    const char = e.key;

    // Allow control keys (backspace, arrows, delete, tab, ctrl+c/v)
    if (e.ctrlKey || e.metaKey || char.length > 1) return;

    // Allow only letters + space
    if (!/^[a-zA-Z\s]$/.test(char)) {
        e.preventDefault();
    }
});


/* BLOCK INVALID PASTE */
$(document).on("paste", '#ContactForm-name', function (e) {
    e.preventDefault();

    let pasted =
        (e.originalEvent || e).clipboardData.getData("text") || "";

    // Remove everything except letters + space
    pasted = pasted.replace(/[^a-zA-Z\s]/g, "");

    // Remove multiple spaces
    pasted = pasted.replace(/\s+/g, " ").trim();

    // Insert cleaned value
    if (document.queryCommandSupported("insertText")) {
        document.execCommand("insertText", false, pasted);
    } else {
        $(this).val($(this).val() + pasted);
    }
});


/* SAFETY: if autofill or mobile paste bypass */
$(document).on("input", '#ContactForm-name', function () {
    let cleaned = $(this).val().replace(/[^a-zA-Z\s]/g, "");
    cleaned = cleaned.replace(/\s+/g, " ");

    if ($(this).val() !== cleaned) {
        $(this).val(cleaned);
    }
});

